import View from './View';

export { default as View, getSearchDropdownItemStyles } from './View';

export default View;
